<script>
export default {
    data() {
        return {
            loadingCsrf: true,
            loading: false,
            data: {
                email: '',
                company_name: '',
                name: '',
                message: '',
            },
            errors: {},
            token: '',
            siteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.data['cf-turnstile-response'] = this.token;
            axios.post('/contact', this.data).then(() => {
                this.$toast.success(this.$t('contact.messages.message_sent'));
                this.$router.push({name: 'home'})
            }).catch().finally(() => {
                this.loading = false;
            })
        }
    },
    mounted() {
        axios.get('/sanctum/csrf-cookie').then(() => {
            this.loadingCsrf = false;
        });
    }
}
</script>

<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">

                        <form @submit.prevent="submit" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('contact.labels.title_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <b-field :label="$t('contact.fields.email')"
                                         :type="errors.email ? 'is-danger' : null"
                                         :message="errors.email ? errors.email[0] : null">
                                    <b-input required
                                             type="email"
                                             v-model="data.email"
                                             icon="at"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('contact.fields.name')"
                                         :type="errors.name ? 'is-danger' : null"
                                         :message="errors.name ? errors.name[0] : null">
                                    <b-input required
                                             v-model="data.name"
                                             icon="account"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('contact.fields.company_name')"
                                         :type="errors.company_name ? 'is-danger' : null"
                                         :message="errors.company_name ? errors.company_name[0] : null">
                                    <b-input required
                                             v-model="data.company_name"
                                             icon="domain"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('contact.fields.message')"
                                         :type="errors.message ? 'is-danger' : null"
                                         :message="errors.message ? errors.message[0] : null">
                                    <b-input required
                                             type="textarea"
                                             v-model="data.message"
                                    ></b-input>
                                </b-field>
                                <section class="mt-2 mb-2">
                                    <vue-turnstile language="pl" :site-key="siteKey"  v-model="token"/>
                                </section>
                                <div class="field">
                                    <b-button type="is-success" native-type="submit"
                                            :disabled="loadingCsrf || loading || !token"
                                            :loading="loadingCsrf || loading">
                                        {{ $t('actions.send') }}
                                    </b-button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
